<template>
<div class="chapter">
<div class="inner_page">
<p class="IVPcenter"></p>
<p class="dedication sgc-2"><span class="dedi-2 sgc-1 sgc-1">To Jane Lakes Willard</span></p>
<p class="dedication sgc-2"></p>
<p class="dedication sgc-2">Sweet lady, Good soldier,</p>
<p class="dedication sgc-2">Faithful companion on the way</p>
<p class="first"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?0e2aabfd